export default {
  path: "/print",
  name: "print",
  component: () => import("@/views/Page.vue"),
  children: [
    {
      path: "/print/list",
      name: "printList",
      component: () => import("@/components/print/list.vue"),
      meta: {
        title: "相关表单"
      }
    },
    {
      path: "/print/detail",
      name: "printDetail",
      component: () => import("@/components/print/printDetail.vue"),
      meta: {
        title: "移动打印"
      }
    },
    {
      path: "/print/pdf",
      name: "printPDF",
      component: () => import("@/components/print/printPDF.vue"),
      meta: {
        title: "打印预览"
      }
    },
    {
      path: "/print/description",
      name: "printDescription",
      component: () => import("@/components/print/printInfo.vue"),
      meta: {
        title: "彩印说明"
      }
    }
  ]
};
